export default {
    name: 'ItemSlot',
    functional: true,
    inject: ['listRoot'],
    props: {
        data: {
            type: Object,
            default: null
        },
        slotname:{
            type:String
        }
    },
    render: (h, ctx) => {   
        try {
            return h('div', ctx.injections.listRoot.$scopedSlots[ctx.props.slotname]({            
                data: ctx.props.data        
            }));
        } catch (error) {
            console.error(error.message)
            if(!ctx.injections.listRoot.$scopedSlots[ctx.props.slotname]){
                console.error("未配置插槽")
            }           
        }       
    }
};
